import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import {UpArrow} from "../page-shipment-tracking/ShipmentTrackingPageComponents";
import {Button, Typography} from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import Container from "@material-ui/core/Container";
import SearchField from "../form/SearchFiled";
import {useNavigate, useLocation} from 'react-router-dom';
import {PUBLIC_TRACKING_PATH} from "../../layouts/navigation/Navigator";
import queryString from 'query-string';
import {getDomain} from "../../api/BackendRestClient";


const SITE_KEY = "6LchNnAUAAAAADPRkIJgy1-niGiWHw8M9lUZnhMV";
// const SECRET_KEY = "6LchNnAUAAAAAJklszDA0ocKOri5xZSXrn2_xRYj";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center"
        },
        recaptcha: {
            width: 305,
            margin: 10
        }

    }),
);

declare global {
    interface Window {
        recaptchaOptions: { useRecaptchaNet: boolean }
    }
}

const PublicTrackingSearch = () => {

    window.recaptchaOptions = {
        useRecaptchaNet: true,
    };

    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const {search} = queryString.parse(location.search) as {
                        search?: string;
                    };
    const domain = getDomain();
    const [recaptchaValid, setRecaptchaValid] = React.useState(false);

    const [query, setQuery] = React.useState<string | undefined>(search);
    const [searching, setSearching] = React.useState(false);

    function reCaptchaChange(value) {
        setRecaptchaValid(!!value);
    }

    function executeSearch() {
        setSearching(true);
        if (recaptchaValid) {
            navigate({
                pathname: PUBLIC_TRACKING_PATH,
                search: `search=${query}`
            })
        }
    }


    return (<div className={classes.root}>


            <Container maxWidth="md">
                <SearchField
                    caption={domain === "VCP" ? t("form.search.public-caption-vcp") : t("form.search.public-caption")}
                    searchQuery={query}
                    setSearchQuery={setQuery}
                    executeSearch={executeSearch}
                />
            </Container>

            <ReCAPTCHA
                className={classes.recaptcha}
                sitekey={SITE_KEY}
                onChange={reCaptchaChange}
            />


            {searching && !recaptchaValid && <Typography variant="body2" component="p" color="error">
                {t("public-tracking.info.recaptcha-error")}
            </Typography>}

            <UpArrow/>


            <Button variant="contained" color="primary" size="small"
                    className={classes.recaptcha}
                    onClick={executeSearch}
                    fullWidth={false}>{t("public-tracking.button.search")}</Button>

        </div>
    );
};


export default PublicTrackingSearch;
